import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';

import css from 'css';

import { msg, safeCssClass, calculateDiscountPercentage, gtmPush, opportunityErrorMessage } from 'helpers';

import CloseIcon from 'images/CloseIcon';

import {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckoutLoading,
    removeCheckoutOpportunityCourse,
    removeCheckoutOpportunityProgram,
    resetCheckoutOpportunity,
    resetCheckout,
    setCheckoutVisibility,
    setCheckoutOpportunityId,
    setCheckoutOpportunityAmount,
    setCheckoutOpportunityPayableAmount,
    setCheckoutError
} from 'store';

const Wrapper = styled.section``

const CartSummary = styled.div`
    display: flex;
    flex-flow: column;
    margin-bottom: 30px;
    margin-bottom: 30px;
    color: #FFFFFF;

    .delivery {
        font-size: 1.5em;
        margin: 15px 0;

        &:first-child {
            margin-top: 0;
        }
    }
`;

const CartSummaryItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #2472b9;

    .description {
        width: 100%;

        .name {
            font-size: 1.125em;
            font-weight: bold;
            padding-bottom: 5px;
        }

        .totals {
            display: flex;
            flex-flow: column;
            padding-bottom: 5px;
    
            .price {
                padding-left: 10px;
            }
    
            .full-price .price {
                font-weight: bold;
            }
    
            &.has-discount {
                .full-price .price {
                    font-weight: normal;
                    text-decoration: line-through;
                }
    
                .discount-price .price {
                    font-weight: bold;
                }
            }
    
            & > div {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }
    }

    button {
        cursor: pointer;
        margin-left: 15px;
    }
`

const CloseButton = styled.button``

const PaymentSummary = styled.div`
    color: #FFFFFF;
    margin-bottom: 30px; 

    .total-price {
        font-size: 26px;
        padding-bottom: 5px;
    
        .price {
            font-weight: bold;
        }
    }
`

const LoanSummary = styled.div`
    margin-bottom: 30px;

    ul {
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            display: flex;
            flex-flow: row;
            color: #FFFFFF;
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            label{
                font-weight: 300;
            }

            .check {       
                border-radius: 100%;
                height: 20px;
                width: 20px;
                margin-right: 10px;
                background: #FFFFFF;

                .inside {
                    left: 5px;
                    color: ${css.colors.blue};
                    bottom: 1px;
                }
            }
        }
    }
`

class Cachier extends Component {
    constructor() {
        super()
        this.state = {
            amountLoaded: null,
            autumnLoan: 0,
            springLoan: 0,
            loanLoaded: null,
        }
    }

    componentDidMount() {
        this.props.setCheckoutTitle('Oppsummering');
        this.props.setCheckoutSubtitle('Ser alt greit ut?');
        this.props.setCheckoutNextCallback(this._onSubmit.bind(this));

        // temporarily disable loan calculation
        // it should be reviewed together with the new implementation os schedules and the review the offerint/term solution
        // loanLoaded true should be removed with proper loan calculation setup
        //this._onLoadLoanCalculation();
        this.setState({ loanLoaded: true });

        if(this.props.opportunity.registrationType === 'DEFAULT_CHECKOUT') {
            if (this.props.opportunity.id) {
                this._onUpdateOpportunity();
            } else {
                this.props.setCheckoutError(msg('unableToRegister'));
                this.setState({ amountLoaded: true });
            }
        }else  if(this.props.opportunity.registrationType === 'SALESFORCE_LINK_CHECKOUT') {
            this._onLoadTotalPrice();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.amountLoaded !== this.state.amountLoaded || prevState.loanLoaded !== this.state.loanLoaded) {
            if (this.state.amountLoaded && this.state.loanLoaded) {
                this.props.setCheckoutLoading(false);
            } else {
                this.props.setCheckoutLoading(true)
            }
        }
    }

    _mapProdutsToList = (products) => {
        let categorizedList = [];

        products.filter(product => !!product.delivery).forEach(product => {
            if (!categorizedList[product.delivery]) {
                categorizedList[product.delivery] = [];
            }

            categorizedList[product.delivery].push(product);
        });
        
        categorizedList = Object.keys(categorizedList).sort().reduce(function (result, key) {
            result[key] = categorizedList[key];
            result[key].sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                if(a.semester < b.semester) {
                    return -1;
                }

                if(a.semester > b.semester) {
                    return 1;
                }
                return 0;
            });
            return result;
        }, {});

        return categorizedList;
    }

    _onLoadLoanCalculation = async () => {
        const { programs, courses } = this.props.opportunity;

        this.setState({ loanLoaded: false });

        await api.getLoanCalculation({ programs: programs, courses, courses }).then(response => {
            this.setState({ autumnLoan: response.data.autumnLoan });
            this.setState({ springLoan: response.data.springLoan });
            this.setState({ loanLoaded: true });
        }).catch(error => {
            this.setState({ loanLoaded: true });
        });
    }

    _onLoadTotalPrice(){
        
        this.setState({ amountLoaded: false });

        const { programs, courses } = this.props.opportunity;
        let totalPrice = 0;

        courses.forEach( function(course) {
            totalPrice += course.price ? course.price : 0;
        });

        programs.forEach( function(program) {
            totalPrice += program.price ? program.price : 0;
        });

        this.props.setCheckoutOpportunityAmount(totalPrice);
        this.props.setCheckoutOpportunityPayableAmount(totalPrice);

        this.setState({ amountLoaded: true });
    }

    _shouldExit() {
        const { courses, programs } = this.props.opportunity;

        if (courses.length + programs.length <= 0) {
            this.props.resetCheckoutOpportunity();
            this.props.resetCheckout();
            this.props.setCheckoutVisibility(false);

            return true;
        }

        return false;
    }

    _onHandleRemoveCartItem = async (product) => {
       this._onRemoveCartItemTracking(product);

        switch (product.objectType) {
            case 'course':
                await this.props.removeCheckoutOpportunityCourse(product);
                break;
            case 'program':
                await this.props.removeCheckoutOpportunityProgram(product);
                break;
        }

        if (!this._shouldExit()) {
            //this._onLoadLoanCalculation();
            if(this.props.opportunity.registrationType === 'DEFAULT_CHECKOUT') {
                this._onUpdateOpportunity();
            }else  if(this.props.opportunity.registrationType === 'SALESFORCE_LINK_CHECKOUT') {
                this._onLoadTotalPrice();
            }
        }
    }

    _onRemoveCartItemTracking = product => {
        gtmPush({
            'event': 'removeFromCart',
            'ecommerce': {
                'currencyCode': 'NOK',
                'add': {
                    'products': [{
                        'name': product.name,
                        'id': product.id,
                        'price': product.price,
                        'brand': 'bjorknesprivatskole',
                        'category': product.academicArea || product.category || '',
                        'variant': product.semester,
                        'quantity': 1
                    }]
                }
            }
        });
    }

    _onUpdateOpportunity = () => {
        if (!this.props.opportunity.id) {
            this.props.setCheckoutError(msg('unableToRegister'));
            this.setState({ amountLoaded: true });
            return Promise.resolve(false);
        }

        const parameters = {
            customerId: this.props.opportunity.customerId,
            educationalGoal: this.props.opportunity.educationalGoal,
            attachments: this.props.opportunity.attachments,
            comment: this.props.opportunity.comment,
            programs: this.props.opportunity.programs,
            courses: this.props.opportunity.courses,
            transactionId: null,
            reservedAmount: 0,
            paymentMethod: null,
            coupon: this.props.opportunity.coupon,
            partialObject: this.props.opportunity.partialObject,
        }

        this.setState({ amountLoaded: false });

        return api.updateOpportunity(this.props.opportunity.id, parameters).then(response => {
            this.props.setCheckoutOpportunityAmount(response.data.opportunityValue);
            this.props.setCheckoutOpportunityPayableAmount(response.data.opportunityPayable);

            this.setState({ amountLoaded: true });

            return true;
        }).catch(error => {
            this.props.setCheckoutError(opportunityErrorMessage(error, 'unableToRegister'));

            this.setState({ amountLoaded: true });

            return false;
        });
    }

    _onSubmit = () => {
        if (this.props.opportunity.payableAmount <= 0) {
            this.props.setCheckoutError(msg('unableToContinuePayment'));

            return false;
        }

        return new Promise(resolve => { resolve(true); });
    }

    render() {
        const { amountLoaded, autumnLoan, springLoan } = this.state;
        const { courses, programs, amount, payableAmount } = this.props.opportunity;

        const products = this._mapProdutsToList([...courses, ...programs]);

        return (
            <Wrapper>
                <CartSummary>
                    {Object.entries(products).map(([category, products]) => {
                        return (
                            <React.Fragment key={safeCssClass(category)}>
                                <span className="delivery">
                                    {category}
                                </span>
                                {products.map(product => {
                                    let fullPrice = product.price;
                                    let discountedPrice = null;

                                    if(product.bundledCourses && product.bundledCourses.length) {
                                        product.originalPrice = product.bundledCourses.map(item => item.price).reduce((prev, next) => prev + next);
                                    }

                                    if (product.price < product.originalPrice) {
                                        fullPrice = product.originalPrice;
                                        discountedPrice = product.price;
                                    }
                                    return (
                                        <CartSummaryItem key={product.offeringId}>
                                            <div className="description">
                                                <span className="name">
                                                    {product.name} {product.semester ? ' - ' + product.semester : ''}
                                                </span>
                                                <div className={discountedPrice ? "totals has-discount" : "totals"}>
                                                    <div className="full-price">
                                                        <span> Pris </span>
                                                        <span className="price"> {parseInt(fullPrice).toLocaleString('de-DE')},- </span>
                                                    </div>
                                                    {discountedPrice &&
                                                        <div className="discount-price">
                                                            <span> Rabattert pris ({calculateDiscountPercentage(product.originalPrice, product.price)}%) </span>
                                                            <span className="price"> {parseInt(discountedPrice).toLocaleString('de-DE')},- </span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <CloseButton onClick={() => this._onHandleRemoveCartItem(product)}>
                                                <CloseIcon color="#FFFFFF" />
                                            </CloseButton>
                                        </CartSummaryItem>
                                    )
                                })}
                            </React.Fragment>
                        )
                    })}
                </CartSummary>
                <PaymentSummary>
                    <div className="total-price">
                        Total: <span className="price"> {amountLoaded ? parseInt(amount).toLocaleString('de-DE') : '-'},- </span>
                    </div>
                    {(amountLoaded && amount !== payableAmount) &&
                         <div className="payable-price">
                             Hvorav {parseInt(payableAmount).toLocaleString('de-DE')},- betales ved påmelding
                         </div>
                     }
                    <div style={{ fontSize: "17px" }}>
                        * I tillegg vil det påløpe en semesteravgift på 950,- per semester. 
                        Denne avgiften gjelder ikke hvis du kun kjøper labkurs eller forkurs.
                    </div>
                </PaymentSummary>
                {(autumnLoan > 0 || springLoan > 0) &&
                    <LoanSummary>
                        <ul>
                            {autumnLoan > 0 &&
                                <li>
                                    <div className="check"><div className="inside">&#10003;</div></div>
                                    <label> Kvalifisert til {autumnLoan}% studielån høst </label>
                                </li>
                            }
                            {springLoan > 0 &&
                                <li>
                                    <div className="check"><div className="inside">&#10003;</div></div>
                                    <label> Kvalifisert til {springLoan}% studielån vår </label>
                                </li>
                            }
                        </ul>
                    </LoanSummary>
                }
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
    checkoutCart: state.checkoutCart,
    timeSchedule: state.timeSchedule,
});

const actions = {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckoutLoading,
    removeCheckoutOpportunityCourse,
    removeCheckoutOpportunityProgram,
    resetCheckoutOpportunity,
    resetCheckout,
    setCheckoutVisibility,
    setCheckoutOpportunityId,
    setCheckoutOpportunityAmount,
    setCheckoutOpportunityPayableAmount,
    setCheckoutError
}

export default connect(mapStateToProps, actions)(Cachier);



// WEBPACK FOOTER //
// ./src/partials/Checkout/Cachier.js